
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.382 15.022h-8.26V4.352h4.836v3.427h3.424v7.243zM11.03 4.572l2.128 2.124H11.03V4.572zm3.337 1.812a.36.36 0 01.095.241v8.464c0 .56-.454 1.014-1.014 1.014h-8.39c-.56 0-1.013-.454-1.013-1.014v-10.8c0-.56.453-1.015 1.014-1.015h6.052c.103 0 .195.043.262.111l.001.001 2.978 2.978.005.005.006.007.004.008zM2.413 12.138a.54.54 0 01.54.54l-.001.004a.54.54 0 01-.54.537h-.227c-.56 0-1.014-.454-1.014-1.014v-10.8C1.17.844 1.625.39 2.185.39h6.052A.36.36 0 018.5.501H8.5c.26.262.522.522.783.784a.016.016 0 00-.004.004.545.545 0 01-.008.747.544.544 0 01-.77-.005l-.564-.565-5.69.001v10.671h.165z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    